import { addMonths } from 'date-fns';
import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';
import { geraFiltroHttp } from '../util/functions';

class AuditoriaService extends BaseService {
  constructor() {
    super(ConfigApi.auditoriaURL);
  }

  getFilter() {
    return new Filter();
  }

  async findAllAcoes() {
    this.setLoading(true);
    try {
      const response = await this.api.get(`${this.url}/acoes`);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  async exportCSV(filter) {
    this.setLoading(true);
    try {
      const filterGet = geraFiltroHttp(filter);
      const response = await this.api.get(`${this.url}/export/csv${filterGet}`, {
        responseType: 'arraybuffer',
      });

      const path = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = path;
      link.setAttribute('download', 'auditoria.csv');
      document.body.appendChild(link);
      link.click();
    } finally {
      this.setLoading(false);
    }
  }
}

class Filter {
  constructor() {
    this.acao = '';
    this.conteudo = '';

    this.dataInicio = addMonths(new Date(), -1);
    this.dataFim = new Date();
    this.limit = 0;
    this.page = 0;
  }
}
export default new AuditoriaService();
